import { buttonPropsSchema } from '../component-catalog.js';
export const buttonDefinition = {
    type: 'Button',
    category: 'interactive',
    propsSchema: buttonPropsSchema,
    isDataBacked: false,
    needsMeasuredDims: false,
    description: 'Clickable button affordance. Props: label (required), variant? ("primary" | "secondary" | "ghost"), icon?, disabled?.',
};
//# sourceMappingURL=Button.js.map